import {
   FloatingFocusManager,
   FloatingOverlay,
   FloatingPortal,
   useClick,
   useDismiss,
   useFloating,
   useInteractions,
   useRole,
   useTransitionStyles,
} from '@floating-ui/react';
import Scrollbar from 'components/Scrollbar';
import { any, bool, func, string } from 'prop-types';
import styled from 'styled-components';
const StyledDrawer = styled(FloatingOverlay)`
   align-items: center;
   background-color: rgba(0, 0, 0, 0.4);
   display: flex;
   height: 100vh;
   justify-content: end;
   left: 0;
   overflow: hidden !important;
   top: 0;
   width: 100%;
   @media (max-width: 414px) {
      padding: 12px;
   }
   & .floating-ui-modal {
      height: 100%;
      padding: 0;
      position: relative;
      & .floating-ui-modal-close {
         align-items: center;
         border: none;
         cursor: pointer;
         display: flex;
         height: 28px;
         justify-content: center;
         outline: none;
         padding: 0;
         position: absolute;
         right: 16px;
         top: 16px;
         width: 28px;
         @media (max-width: 414px) {
            right: 12px;
            top: 12px;
         }
      }
   }
`;
const Drawer = ({
   children,
   isDisabled = false,
   maxWidth = '600px',
   onClose,
   onOpen,
   open = false,
}) => {
   const { refs, context } = useFloating({
      open,
      onOpenChange: open => {
         if (open) {
            onOpen(open);
         } else {
            onClose(open);
         }
      },
   });
   const { styles, isMounted } = useTransitionStyles(context, {
      common: { transformOrigin: 'center' },
      duration: 300,
      initial: {
         opacity: 0,
         transform: 'translateX(50px)',
      },
      open: {
         opacity: 1,
         transform: 'translateX(0)',
      },
   });
   const click = useClick(context);
   const role = useRole(context);
   const dismiss = useDismiss(context, {
      enabled: !isDisabled,
      escapeKey: true,
      outsidePressEvent: 'click',
   });
   const { getFloatingProps } = useInteractions([click, dismiss, role]);
   return (
      isMounted && (
         <FloatingPortal id='floating-ui-portal'>
            <StyledDrawer lockScroll>
               <FloatingFocusManager context={context}>
                  <div
                     {...getFloatingProps()}
                     className='floating-ui-modal bg-[#ffffff] dark:bg-[#2E2D2D]'
                     ref={refs.setFloating}
                     style={{ ...styles, width: maxWidth, maxWidth }}
                  >
                     <Scrollbar>{children}</Scrollbar>
                     {!isDisabled && (
                        <button
                           className='floating-ui-modal-close text-[#292B32] dark:text-[#f2f2f2]'
                           onClick={() => onClose(false)}
                        >
                           <svg
                              fill='currentColor'
                              height='22'
                              viewBox='0 0 24 24'
                              width='22'
                           >
                              <path d='M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z'></path>
                           </svg>
                        </button>
                     )}
                  </div>
               </FloatingFocusManager>
            </StyledDrawer>
         </FloatingPortal>
      )
   );
};
Drawer.propTypes = {
   children: any,
   isDisabled: bool,
   maxWidth: string,
   onClose: func,
   onOpen: func,
   open: bool,
};
export default Drawer;
